// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
const CIRCLE_SIZE = 44;
export const Spinner = function Spinner(_a) {
    var { ref, size = 40, thickness = 7.2, className, style } = _a, props = __rest(_a, ["ref", "size", "thickness", "className", "style"]);
    return (_jsx("div", Object.assign({ ref: ref, role: "progressbar" }, props, { className: classNames('inline-block animate-spin animate-ease-linear animate-iteration-infinite color-inherit animate-duration-1400 transform-origin-[50%_50%]', className), style: Object.assign({ width: size, height: size }, style), children: _jsx("svg", { className: "block", viewBox: `${CIRCLE_SIZE / 2} ${CIRCLE_SIZE / 2} ${CIRCLE_SIZE} ${CIRCLE_SIZE}`, children: _jsx("circle", { className: "stroke-current animate-spinner-stroke animate-ease-in-out animate-iteration-infinite animate-duration-1400 [stroke-dasharray:80_200] [stroke-dashoffset:0]", cx: CIRCLE_SIZE, cy: CIRCLE_SIZE, r: (CIRCLE_SIZE - thickness) / 2, fill: "none", strokeWidth: thickness }) }) })));
};
export const FullScreenSpinner = function FullScreenSpinner(_a) {
    var { ref } = _a, props = __rest(_a, ["ref"]);
    return (_jsx("div", { ref: ref, className: "flex flex-row gap-4 w-full flex-1 justify-center items-center self-stretch", children: _jsx(Spinner, Object.assign({}, props)) }));
};
//# sourceMappingURL=Spinner.js.map